module.exports = {
    "Empty": `\u{5E8}\u{5D9}\u{5E7}`
};


//# sourceMappingURL=he-IL.main.js.map
